import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Wallet, FileText } from "lucide-react";
import { toast } from "sonner";

export default function MyPayslips() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/my/payslips").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const download = (fileId, filename) => {
    const token = localStorage.getItem("hr_token");
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/files/${fileId}/download?auth=${token}`;
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "payslip.pdf";
    a.target = "_blank";
    a.click();
  };

  return (
    <div data-testid="my-payslips-page">
      <PageHeader
        title="My payslips"
        subtitle="Every payslip your HR/Finance team has issued is available here. Download as PDF."
      />

      {loading ? (
        <Card className="hr-card p-8 text-center text-sm text-gray-500">Loading…</Card>
      ) : items.length === 0 ? (
        <Card className="hr-card p-10 text-center" data-testid="my-payslips-empty">
          <FileText className="h-10 w-10 mx-auto text-gray-300" />
          <div className="font-display text-lg font-semibold mt-3">No payslips yet</div>
          <p className="text-sm text-gray-500 mt-1 max-w-md mx-auto">
            Once your HR team runs payroll for the current month, your payslips will show up here automatically.
          </p>
        </Card>
      ) : (
        <div className="space-y-3">
          {items.map((p) => (
            <Card key={p.file_id} className="hr-card p-5 flex items-center justify-between gap-4 flex-wrap" data-testid={`my-payslip-${p.file_id}`}>
              <div className="flex items-center gap-4 min-w-0">
                <div className="h-10 w-10 rounded-lg bg-[#F26B3A]/5 text-[#0F172A] grid place-items-center shrink-0">
                  <Wallet className="h-5 w-5" />
                </div>
                <div className="min-w-0">
                  <div className="font-display font-semibold text-[#0F172A]">{p.month || "Payslip"}</div>
                  <div className="text-xs text-gray-500 truncate font-mono">{p.filename}</div>
                </div>
              </div>
              <div className="flex items-center gap-6">
                <div className="hidden md:block text-right">
                  <div className="text-[10px] uppercase tracking-wider text-gray-400">Net pay</div>
                  <div className="font-display font-semibold text-[#0F172A]">
                    {p.net ? `₹ ${Number(p.net).toLocaleString("en-IN")}` : "—"}
                  </div>
                </div>
                <Button
                  data-testid={`download-${p.file_id}`}
                  onClick={() => { download(p.file_id, p.filename); toast.success("Download started"); }}
                  className="h-9 bg-[#F26B3A] hover:bg-[#d85d2f]"
                >
                  <Download className="h-4 w-4 mr-1.5" /> Download
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
